<script setup lang="ts">
import { VButton, VIcon } from '@/modules/shared/components'

defineProps<{
  checked: boolean
  disabled: boolean
}>()
</script>

<template>
  <div class="relative">
    <VButton
      class="h-4 w-4 !p-0"
      :class="
        checked
          ? '!bg-gray-200 text-gray-400 opacity-50 shadow-none ring-1 ring-gray-200/20 hover:shadow-none active:shadow-none'
          : ''
      "
      :disabled="disabled"
    ></VButton>
    <span v-show="checked" class="pointer-events-none absolute inset-0 p-0.5 text-sm">
      <VIcon name="Check" class="h-full w-full" />
    </span>
  </div>
</template>
